import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

import { InfoContainer } from './components/Info/styles';

export const Group = styled.article`
  display: flex;
  flex-direction: column;
  & ${InfoContainer}:last-child {
    margin-bottom: 0;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  div {
    width: 100%;
  }
`;

export const Container = styled.section`
  padding-bottom: 32px;

  & ${Group}:last-child {
    margin-top: 32px;
  }

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${ColorPalette.HEX.Lotion};
  }
`;

export const Content = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    max-width: 1300px;
  }
`;

export const HeaderTitle = styled.div`
  font-family: Poppins;
  display: inline;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 80px;
  letter-spacing: -0.2px;
  text-align: center;
  padding: 0px;
  color: ${({ theme }) => theme.simpleHeader.titleColor};
`;

export const Title = styled.h4`
  font-size: 24px;
  font-weight: 600;
  margin: 32px 0;
  line-height: 1.33;
  letter-spacing: -0.4px;
  color: ${ColorPalette.HEX.PineTree};

  @media ${({ theme }) => theme.device.mobile} {
    margin-left: 16px;
  }
`;

export const EditIcon = styled.button`
  width: 24px;
  height: 24px;
  background-image: url('/corporate/images/billing/edit.svg');
  background-color: ${ColorPalette.Transparent};
  float: right;
  margin-right: 16px;
  cursor: pointer;
`;

export const StyledButton = styled(Button)`
  height: 56px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  margin-top: 32px;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 500px;
    margin-left: auto;
  }

  @media ${({ theme }) => theme.device.mobile} {
    background: ${ColorPalette.HEX.White};
    width: 100%;
    align-items: center;
    justify-content: center;
    position: fixed;
    padding: 16px;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;
